import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [{
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2xmrA8enNHsriJGhiecH3w/slide_2.png',
  title: 'No Estás Rota. Estás Agotada.',
  alt: 'Plan realista de 30 días para recuperar tu energía'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9e7jk1Qmx3tDs5nPBxkbSB/slide_7.png',
  title: 'Rutinas Exprés para Mamás',
  alt: 'Rutinas para recargar energía'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7oisJMnKnSAXKxqpvMph1X/slide_6.png',
  title: 'Diálogo Interno',
  alt: 'Reprograma tu voz interna'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oCk8y6QERcoJEtvtiqkhsj/slide_5.png',
  title: 'Adiós Carga Mental',
  alt: 'El plan simple para reducir tu estrés mental'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dB1Ge66ymwtZkz4KjWfdfo/slide_4.png',
  title: 'El Poder del No',
  alt: 'Cómo poner límites en familia y trabajo'
}, {
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/d2v1XS9bigknDqdtvFr9Gy/slide_3.png',
  title: 'Kit de Emergencia Emocional',
  alt: 'Respuestas para el caos diario'
}];
export function BonusSlideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const handleNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % slides.length);
  };
  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  };
  const handleDotClick = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
      scale: 0.95
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1
    },
    exit: (direction: number) => ({
      x: direction > 0 ? -1000 : 1000,
      opacity: 0,
      scale: 0.95
    })
  };
  return <div className="relative w-full" data-id="element-17">
      {/* Slideshow Container */}
      <div className="relative overflow-hidden rounded-3xl shadow-2xl bg-white" data-id="element-18">
        {/* Aspect ratio container for consistent sizing */}
        <div className="relative w-full" style={{
        paddingBottom: '75%'
      }} data-id="element-19">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-20">
            <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.3
            },
            scale: {
              duration: 0.3
            }
          }} className="absolute inset-0 flex items-center justify-center p-4 sm:p-8 md:p-12" data-id="element-21">
              <img src={slides[currentIndex].image} alt={slides[currentIndex].alt} className="w-full h-full object-contain" data-id="element-22" />
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Navigation Arrows - Desktop */}
        <div className="hidden md:block" data-id="element-23">
          <motion.button onClick={handlePrev} whileHover={{
          scale: 1.1,
          x: -4
        }} whileTap={{
          scale: 0.9
        }} className="absolute left-4 lg:left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/95 hover:bg-white rounded-full shadow-xl flex items-center justify-center text-text-main transition-colors z-10 backdrop-blur-sm" aria-label="Slide anterior" data-id="element-24">
            <ChevronLeft className="w-7 h-7" data-id="element-25" />
          </motion.button>

          <motion.button onClick={handleNext} whileHover={{
          scale: 1.1,
          x: 4
        }} whileTap={{
          scale: 0.9
        }} className="absolute right-4 lg:right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/95 hover:bg-white rounded-full shadow-xl flex items-center justify-center text-text-main transition-colors z-10 backdrop-blur-sm" aria-label="Siguiente slide" data-id="element-26">
            <ChevronRight className="w-7 h-7" data-id="element-27" />
          </motion.button>
        </div>

        {/* Navigation Arrows - Mobile (Bottom) */}
        <div className="md:hidden absolute bottom-4 left-0 right-0 flex justify-center gap-4 z-10" data-id="element-28">
          <motion.button onClick={handlePrev} whileTap={{
          scale: 0.9
        }} className="w-12 h-12 bg-white/95 rounded-full shadow-xl flex items-center justify-center text-text-main backdrop-blur-sm" aria-label="Slide anterior" data-id="element-29">
            <ChevronLeft className="w-6 h-6" data-id="element-30" />
          </motion.button>

          <motion.button onClick={handleNext} whileTap={{
          scale: 0.9
        }} className="w-12 h-12 bg-white/95 rounded-full shadow-xl flex items-center justify-center text-text-main backdrop-blur-sm" aria-label="Siguiente slide" data-id="element-31">
            <ChevronRight className="w-6 h-6" data-id="element-32" />
          </motion.button>
        </div>
      </div>

      {/* Progress Dots */}
      <div className="flex justify-center gap-2 sm:gap-3 mt-6 sm:mt-8" data-id="element-33">
        {slides.map((_, index) => <motion.button key={index} onClick={() => handleDotClick(index)} whileHover={{
        scale: 1.2
      }} whileTap={{
        scale: 0.9
      }} className={`rounded-full transition-all ${index === currentIndex ? 'w-10 sm:w-12 h-3 bg-primary' : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ver slide ${index + 1}: ${slides[index].title}`} data-id="element-34" />)}
      </div>

      {/* Slide Title & Description */}
      <motion.div key={currentIndex} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.5
    }} className="text-center mt-6 sm:mt-8 px-4" data-id="element-35">
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-serif text-text-main mb-2 sm:mb-3" data-id="element-36">
          {slides[currentIndex].title}
        </h3>
        <p className="text-base sm:text-lg md:text-xl text-text-muted max-w-2xl mx-auto" data-id="element-37">
          {slides[currentIndex].alt}
        </p>
      </motion.div>
    </div>;
}